'use client';

import { FccLogo } from '@jouzen/ecom-components/icons/FccLogo';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

interface FccComplianceStatementTemplateProps {
  readonly productKey: MessageKey;
}

const FccComplianceStatementTemplate = ({
  productKey,
}: FccComplianceStatementTemplateProps) => {
  const t = useTranslations();

  return (
    <LayoutGrid data-cy="fcc-compliance-statement-template">
      <GridItem
        colStart={{ sm: 'main', md: 3, xl: 6 }}
        colEnd={{ sm: 'main', md: 23, xl: 20 }}
      >
        <Typography variant="h1" className="mb-4 text-center">
          ŌURA
        </Typography>
        <Typography
          className="mb-6 text-center text-3xl font-bold"
          Element="h1"
        >
          {t('fcc_sdoc_title')}
        </Typography>
        <Typography className="mb-6 text-xl">{t('fcc_sdoc_copy')}</Typography>
        <Typography className="mb-6 text-center text-xl font-extrabold">
          {t('fcc_sdoc_oura')}
        </Typography>
        <Typography className="mb-8 text-center text-xl font-extrabold">
          Elektroniikkatie 10, 90590 Oulu, Finland
        </Typography>
        <Typography className="mb-8 text-xl font-medium">
          <RichText messageKey={productKey} />
        </Typography>
        <Typography className="mb-4 text-center text-xl font-medium underline">
          {t('fcc_sdoc_party')}
        </Typography>
        <Typography className="mb-4 text-center text-xl font-bold">
          OURARING INC
        </Typography>
        <Typography className="mb-4 text-center text-xl font-bold">
          222 Kearny St. 7th floor San Francisco 94108, California, USA
        </Typography>
        <Typography className="mb-8 text-center text-xl font-bold">
          FRN 0035310408
        </Typography>
        <Typography className="mb-4 text-xl font-medium">
          {t('fcc_sdoc_footer_one')}
        </Typography>
        <Typography className="mb-4 text-xl font-medium">
          {t('fcc_sdoc_footer_two')}
        </Typography>
        <Typography className="mb-16 text-xl font-medium">
          {t('fcc_sdoc_footer_three')}
        </Typography>
        <div className="mb-10 flex flex-row justify-center">
          <FccLogo width={80} />
        </div>
      </GridItem>
    </LayoutGrid>
  );
};

export default FccComplianceStatementTemplate;
